import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { MethodSection } from '../components/MethodSection';
import { AudienceSection } from '../components/AudienceSection';
import { StepsSection } from '../components/StepsSection';
import { ProofAndFAQ } from '../components/ProofAndFAQ';
import { OfferCTA } from '../components/OfferCTA';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen w-full bg-night-900 text-cream-100 font-body selection:bg-gold-500/30" data-id="element-225">
      <Hero data-id="element-226" />
      <ProblemSection data-id="element-227" />
      <MethodSection data-id="element-228" />
      <AudienceSection data-id="element-229" />
      <StepsSection data-id="element-230" />
      <ProofAndFAQ data-id="element-231" />
      <OfferCTA data-id="element-232" />
      <Footer data-id="element-233" />
    </main>;
}